import * as React from "react";
import { PieChart, pieArcLabelClasses } from "@mui/x-charts/PieChart";
import { Card, CardContent, CardHeader } from "@mui/material";
import { Box } from "@mui/system";

const sizing = {
  // width: 300,
  height: 250,
};

export default function InvClassPieChart(props) {
  const { data } = props;
  const isMobile = window.matchMedia("(max-width: 768px)").matches;
  const TOTAL = data.map((item) => item.value).reduce((a, b) => a + b, 0);

  const getArcLabel = (params) => {
    const percent = params.value / TOTAL;
    return `${(percent * 100).toFixed(0)}%`;
  };

  return (
    <Card m={5}  sx={{height: "355px"}}>
      <CardHeader title="Percentage of Status" />
      <CardContent>
        {TOTAL > 0 ? (<PieChart
          series={[
            {
              data,
              arcLabel: getArcLabel,
              highlightScope: { faded: "global", highlighted: "item" },
              faded: { innerRadius: 10, additionalRadius: -30, color: "gray" },
            },
          ]}
          slotProps={{
            legend: {
              direction: "column",
              position: { vertical: "middle", horizontal: "right" },
              hidden: isMobile ? true : false,
              padding: isMobile ? -80 : 0,
            },
          }}
          sx={{
            [`& .${pieArcLabelClasses.root}`]: {
              fill: "white",
              fontSize: 12,
            },
          }}
          {...sizing}
        />) : (<Box display="flex" justifyContent="center" alignContent="center">No Data</Box>)}
      </CardContent>
    </Card>
  );
}
